<template>
    <div class="profileSettin">
        <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
              <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <P>设置</P>
            </div>
            <div></div>
        </div>
        <!-- 账户信息 -->
        <div class="profileOut">
            <div class="account"><p>账户</p><p>{{user.CustomerCode}}</p></div>
            <!-- <div class="nickname"><p>昵称</p><p>{{user.CustomerNickName}}<span class="iconfont iconyoujiantou"></span></p></div> -->
            <div class="phone" @click="BindPhone"><p>绑定手机</p><p>{{user.CustomerPhone}}<span class="iconfont iconyoujiantou"></span></p></div>
            <!-- <div class="coupon"><p>现金券</p><p>0</p></div> -->
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    computed: {
    ...mapState(['user']),
    
 },
 created () {
     console.log(this.user)
 },
 methods: {
     back () {
     this.$router.back()
   },
   BindPhone () {
     this.$router.push('/phoneSettin')
   }
 }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.profileSettin
  background: rgb(240, 240, 240)
  height: 100vh
  .header
   position: fixed
   z-index: 90
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 44px
   align-items: center
   background-color: white
   font-weight: bold
   .header-left
     padding-left: 8px
     height: 100%
     width: 40px
     display: flex
     align-items: center
   .header-right
     padding-right: 8px
     width: 40px
   .header-center
     font-size: 20px
     width: 80px
  .profileOut
    width: 100%
    padding-top: 56px
    &>div
     display: flex
     justify-content: space-between
     align-items: center
     height: 56px
     background-color: white
     width: 100%
     margin: 0 auto
     border-bottom: 1px solid #eee
     padding: 0 6px
     box-sizing: border-box
     &>p
      display: flex
      justify-content: space-between
      align-items: center
     & .iconyoujiantou
       font-size: 22px
      
</style>



// WEBPACK FOOTER //
// src/pages/Profile/ProfileSettin.vue